jQuery(function($){
    if ($('.horizontally-moving-text').length == 0){
        return;
    }

    const marquee2Span = document.querySelector('.marquee2 span');
    setTimeout(function () {
        marquee2Span.classList.add('loop'); 
    }, 7000);
});